import React from "react";
import classNames from "classnames";
import * as moment from "moment";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

import { getImageURL } from "../../utils/functions";

const SingleItem = ({ blogData, assets }) => {
  const { title, description, publishDate, heroImage, body, content } =
    blogData || {};

    const isValidDate = (date) => {
      console.log(!!date && moment(date).isValid())
    }

    isValidDate();

  return (
    <main className="col-lg-7 col-xl-8">
      <article className="full-post vertical-item box-shadow post type-post status-publish format-standard has-post-thumbnail">
        <div className="item-media post-thumbnail">
          {heroImage && <img src={getImageURL(assets, heroImage.sys.id)} alt="img" />}
        </div>

        <div className="item-content">
          <header className="entry-header">
            <p className="mb-0 item-meta d-flex justify-content-sm-start flex-sm-row flex-column justify-content-center flex-wrap">
              <span>
                <a href="#" rel="bookmark">
                  <time
                    dateTime="2018-03-18T15:15:12+00:00"
                    className="published entry-date"
                  >
                    {moment(publishDate).format("DD MMMM, YYYY")}
                  </time>
                </a>
              </span>
              <span>
                <a href="#" rel="bookmark">
                  <time
                    dateTime="2018-03-18T15:15:12+00:00"
                    className="published entry-date"
                  >
                    {moment(publishDate).format("HH:mm")}
                  </time>
                </a>
              </span>
            </p>
            <h4 className="letter-sp-normal font-weight-regular mt-10 mb-20 lh-30">
              <a>{title}</a>
            </h4>

            <div className="divider-15"></div>
          </header>

          <div
            className="entry-content"
            dangerouslySetInnerHTML={{ __html: documentToHtmlString(content) }}
          ></div>
        </div>
      </article>
    </main>
  );
};

export default SingleItem;
